import {useCallback} from 'react';

export function useRedirectHistory() {
  const redirect = useCallback((link) => {
    window.location.href = link;
  }, []);

  return {redirect};
}
